module.exports = __webpack_public_path__ + "images/waitingdd7e36be4c3cc6629aca2370a50ccbb2.gif";